module.exports = __webpack_public_path__ + "static/media/solastalgia-3.885b38f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solastalgia/solastalgia-3.jpg
// module id = 4428
// module chunks = 15